const storePrefix = "/reservations/";

export const buildHref = (href, store, basePath, bypassBasePath) => {
	if (!href) return "";
	if (href[0] === "/") {
		if (store) {
			href = `${storePrefix}${store}${href}`;
		}
		if (!bypassBasePath) {
			href = `${basePath}${href}`;
		}
	}
	return href;
};

export const processHtmlLinks = (html, store, basePath) => {
	if (!html || typeof html !== "string") {
		return html;
	}

	const linkRegex = /<a\b[^>]*\bhref=["']([^"']+)["'][^>]*>/g;

	return html.replace(linkRegex, (match, href) => {
		const newHref = buildHref(href, store, basePath, false);
		return match.replace(href, newHref);
	});
};
